import { useFormikContext } from "formik";
// import Step0 from "./step0";
// import Step1 from "./step1";
// import Step2 from "./step2";
// import Step3 from "./step3";
import Step4 from "./step4";

export default function Steps() {
  const data = useFormikContext<TaxClientSettingsData>();
  // const steps = [Step0, Step1, Step2, Step3, Step4];

  return <Step4 />;
}
